let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7r7DH")).then(() => parcelRequire('in4So'));